import { Permission, Scope } from '@models/permission';

export interface PdfMarkupTokenResponse {
  jwt: string;
  permissions: { permissionId: Permission; scopeId: Scope }[];
}

export interface PdfMarkupAssociation {
  moduleTypeInstanceId: number;
  name: string;
  createdBy: string;
  createdOn: string;
}

export interface PdfMarkupKeyValue {
  key: number;
  value: string;
  name: string;
}

export interface PdfMarkupUser {
  id: number;
  sysUserId: number;
  firstName: string;
  lastName: string;
  name: string;
  email: string;
}

export interface PdfMarkupAssociationDetail {
  moduleTypeInstanceId: number;
  name: string;
  createdBy: string;
  createdOn: string;
  moduleId: number;
  entityId: number;
  screenId: number;
  fileVersionId: number;
}

export interface PdfMarkupVersion {
  fileId: number;
  fileVersionId: number;
  version: number;
  isCurrent: boolean;
  documentId: string;
  mimeType: string;
  createdOn: string;
  fileUrl: string;
  annotationPath: string;
  flattenedDocPath: string;
  coverPath: string;
}

export interface PdfMarkupAddDialogData {
  type: string;
  documentId?: string;
  fileId?: number;
  fileName?: string;
}

export interface PdfMarkupUploadModel {
  fileId: number;
  versionId: number;
  fileName: string;
}

export interface PdfMarkupPickResult {
  documentId?: string;
  fileId?: number;
  fileName?: string;
  filesUploaded?: boolean;
}

export interface PdfMarkupPermissions {
  canDelete?: boolean;
  canDownload?: boolean;
  canEmail?: boolean;
  canPrint?: boolean;
}

export interface PdfMarkupModel {
  name: string;
  createdBy: string;
  createdOn: Date;
  documentId: string;
  entityInstanceId: number;
  moduleTypeInstanceId: number;
  fileId: number;
  fileVersionId: number;
}

export interface PdfMarkupGridItem {
  documentId: string;
  displayName: string;
  fileId: number;
  fileVersion: number;
  isDeletable: boolean;
  associationCount: number;
  preview?: string;
  previewLink: string;
  createdOn: string;
  createdBy: number;
  updatedOn: string;
  updatedBy: number;
  downloadLink: string;
  createdByName?: string;
  updatedByName?: string;
}
